<div class="controls-container">
    <div class="controls-header">Toolbar</div>

    <div class="controls-sub-header">Toolbar</div>

    <pm-toolbar>
        <div class="toolbar-left">Rows (389)</div>
        <div class="toolbar-right">             
            <pm-button class="toolbar-button-container" ButtonClass="button-toolbar">
                <pm-icon-plus IconSize="1" IconClass="icon-green"></pm-icon-plus>                
            </pm-button>
            <pm-button class="toolbar-button-container" ButtonClass="button-toolbar">
                <pm-icon-files-o IconSize="1" IconClass="icon-gray"></pm-icon-files-o>
            </pm-button>
            <div class="toolbar-divider"></div>            
            <pm-button class="toolbar-button-container" ButtonClass="button-toolbar">
                <pm-icon-times IconSize="1" IconClass="icon-red"></pm-icon-times>
            </pm-button>
        </div>
    </pm-toolbar>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/toolbar/toolbar.html